import React, { useEffect, useState } from 'react';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import { Card, Table, Button, Form, Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useQuery, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import Pagination from 'react-js-pagination';
import { DANHMUCVANBANGCHUNGCHI_API } from '@app/utils/apiUrl';
import { DeleteSingle, Get } from '@app/utils/httpProvider';
import { createUrlWithParam } from '../../../../utils/helper';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import { messageToast, objectShowNumber, status200 } from '../../../../utils/define';

// 1. Hàm helper mapping giá trị Enum thành text tiếng Việt
const formatDoiTuongApDung = (value) => {
    if (!value && value !== 0) return '';

    const mapping = {
        'BacSi': 'Bác sĩ',
        'DieuDuong': 'Điều dưỡng',
        'KyThuatY': 'Kỹ thuật y',
        'HoSinh': 'Hộ sinh',
        'YSi': 'Y sĩ',
        'CuNhanDinhDuongLamSang': 'Cử nhân dinh dưỡng lâm sàng',
        1: 'Bác sĩ',
        2: 'Điều dưỡng',
        3: 'Kỹ thuật y',
        4: 'Hộ sinh',
        5: 'Y sĩ',
        6: 'Cử nhân dinh dưỡng lâm sàng'
    };

    if (typeof value === 'string' && value.includes(',')) {
        return value
            .split(',')
            .map(item => mapping[item.trim()] || item.trim())
            .join(', ');
    }

    return mapping[value] || value;
};

// 2. Component Modal Xác nhận Custom (không dùng form, không bị lỗi submit)
const CustomConfirmModal = ({ show, onHide, onConfirm, message }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            backdrop="static"
            style={{ zIndex: 10500 }} // THÊM DÒNG NÀY: Ép Modal nổi lên lớp cao nhất
        >
            <Modal.Header closeButton>
                <Modal.Title className="text-danger">Xác nhận xóa</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Bạn có chắc chắn muốn xóa bản ghi <strong>{message}</strong> không? Hành động này không thể hoàn tác.
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" type="button" onClick={onHide}>
                    Hủy
                </Button>
                <Button variant="danger" type="button" onClick={(e) => onConfirm(e)}>
                    Xác nhận xóa
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

// 3. Component Chính
const DanhMucVanBangChungChi = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (paramUrl.get('page') != null && parseInt(paramUrl.get('page'), 10) !== page) {
        setPage(parseInt(paramUrl.get('page'), 10));
    }
    if (paramUrl.get('size') != null && parseInt(paramUrl.get('size'), 10) !== pageSize) {
        setPageSize(parseInt(paramUrl.get('size'), 10));
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }

    const replaceHistory = (Page, Size, Search) => {
        history.replace(
            createUrlWithParam(location.pathname, {
                page: Page,
                size: Size,
                search: Search
            })
        );
    };

    const { isLoading, isError, error, data, refetch } = useQuery(
        ['danhMucVanBangChungChiData', valueSearch, page, pageSize],
        () => {
            const model = {
                Keyword: valueSearch || '',
                PageIndex: page,
                PageSize: pageSize
            };
            replaceHistory(page, pageSize, valueSearch);
            return Get(DANHMUCVANBANGCHUNGCHI_API.GET_PAGING, null, model);
        },
        {
            keepPreviousData: true
        }
    );

    useEffect(() => {
        refetch();
    }, [pageSize, page]);

    useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            setPage(1);
            replaceHistory(1, pageSize, valueSearch);
        }
    }, [valueSearch]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(Number(e.target.value));
        replaceHistory(page, Number(e.target.value), search);
    };

    const deleteFunc = useMutation((id) => DeleteSingle(`${DANHMUCVANBANGCHUNGCHI_API.DELETE_ITEM}/${id}`));

    const deleteAction = (e, id, name) => {
        e.preventDefault();
        e.stopPropagation();
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = (e) => {
        // Chặn hành vi mặc định
        if (e && e.preventDefault) {
            e.preventDefault();
            e.stopPropagation();
        }

        if (idWantDelete === '') return;

        deleteFunc.mutate(idWantDelete, {
            onSuccess: (res) => {
                if (res.status === status200 || res.status === 201) {
                    toast.success(messageToast.messageToastDeleteSuccess);

                    // Xử lý lùi trang nếu xóa bản ghi cuối cùng của trang
                    if (items.length === 1 && page > 1) {
                        changePage(page - 1);
                    } else {
                        refetch();
                    }
                } else {
                    toast.error(messageToast.messageToastDeleteError);
                }
            },
            onError: (err) => {
                toast.error(err?.message || messageToast.messageToastTryCatch);
            }
        });

        setOpenConfirmDeleteModal(false);
        setIdWantDelete('');
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    const items = data?.data?.$values ? data.data.$values : data?.data || [];
    const totalRecords = data?.totalRecords || 0;

    return (
        <>
            <div className="container-fluid">
                <Card>
                    <Card.Header>
                        <div className="d-flex justify-content-between align-items-center">
                            <h5>Danh mục tên văn bằng chứng chỉ</h5>
                            <div className="d-flex">
                                <NavLink to={URI_INTERNAL.DANHMUCVANBANGCHUNGCHI_CREATE_PATH} className="btn btn-success">
                                    Thêm mới
                                </NavLink>
                            </div>
                        </div>
                    </Card.Header>
                    <Card.Body>
                        <div className="table-responsive">
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>STT</th>
                                        <th>Tên</th>
                                        <th>Đối tượng áp dụng</th>
                                        <th>Hành động</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading ? (
                                        <tr>
                                            <td colSpan={4}>Đang tải...</td>
                                        </tr>
                                    ) : isError ? (
                                        <tr>
                                            <td colSpan={4}>Lỗi: {error?.message || 'Không tải được dữ liệu'}</td>
                                        </tr>
                                    ) : items.length === 0 ? (
                                        <tr>
                                            <td colSpan={4}>Không có dữ liệu</td>
                                        </tr>
                                    ) : (
                                        items.map((item, index) => (
                                            <tr key={item.id || index}>
                                                <td>{(page - 1) * pageSize + index + 1}</td>
                                                <td>{item.ten || item.Ten}</td>
                                                <td>{formatDoiTuongApDung(item.doiTuongApDung || item.DoiTuongApDung)}</td>
                                                <td>
                                                    <NavLink
                                                        className="btn btn-primary btn-sm mr-2"
                                                        to={`${URI_INTERNAL.DANHMUCVANBANGCHUNGCHI_EDIT_PATH}?id=${item.id}`}>
                                                        Sửa
                                                    </NavLink>
                                                    <Button
                                                        type="button"
                                                        variant="danger"
                                                        size="sm"
                                                        onClick={(e) => deleteAction(e, item.id, item.ten || item.Ten)}>
                                                        Xóa
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </Table>
                        </div>

                        <div className="d-flex justify-content-between align-items-center mt-3">
                            <div>
                                <Form.Control as="select" value={pageSize} onChange={onChangeShowNumber} style={{ width: '100px' }}>
                                    {objectShowNumber.map((opt) => (
                                        <option key={opt.value} value={opt.value}>{opt.text}</option>
                                    ))}
                                </Form.Control>
                            </div>
                            <div>
                                <Pagination
                                    itemClass="page-item"
                                    linkClass="page-link"
                                    innerClass="pagination pagination-sm no-margin"
                                    activePage={page}
                                    itemsCountPerPage={pageSize}
                                    totalItemsCount={totalRecords}
                                    pageRangeDisplayed={5}
                                    onChange={changePage}
                                />
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div>

            {/* MODAL ĐẶT Ở NGOÀI CÙNG ĐỂ KHÔNG BỊ XUNG ĐỘT Z-INDEX */}
            <CustomConfirmModal
                show={openConfirmDeleteModal}
                onHide={cancelDelete}
                onConfirm={acceptDelete}
                message={confirmDelMessage}
            />
        </>
    );
};

export default DanhMucVanBangChungChi;